export default {
  wiaVideo: {
    resolve: () => {
      return import(/* webpackMode: 'eager' */ '../wia-video-popup/index.js');
    },
    init: {
      visible: false
    }
  },
  wiaProspect: {
    resolve: () => {
      return import(/* webpackMode: 'eager' */ '../wia-prospect-popup/index.js');
    },
    init: {
      visible: false
    }
  },
  createShortcutMac: {
    resolve: () => {
      return import(/* webpackMode: 'eager' */ '../create-shortcut-mac-popup/index.js');
    },
    init: {
      visible: false
    }
  },
  createShortcutPc: {
    resolve: () => {
      return import(/* webpackMode: 'eager' */ '../create-shortcut-pc-popup/index.js');
    },
    init: {
      visible: false
    }
  },
  testimonialsPopup: {
    resolve: () => {
      return import(/* webpackMode: 'eager' */ '../testimonials-popup/index.js');
    },
    init: {
      visible: false
    }
  }
};



// WEBPACK FOOTER //
// ./home/en-US/js/config/modal-config.js